<button type="button" (click)="sendNotification()" class="btn btn-primary mr-3"
    [disabled]="selections ? selections.length === 0 : false">
    <img class="m-l-0 m-r-5 align-baseline" src="assets/icons/notification.svg" />
    Send Notification
</button>
